var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delete-slot"},[_c('transition',{attrs:{"name":"garbage"}},[(_vm.show)?_c('div',{staticClass:"delete-slot__bucket",class:{
			preparation : _vm.isDeletePreparation,
		}},[_c('span',{staticClass:"iconify",attrs:{"data-icon":"uil:trash-alt","data-width":"32","data-height":"32"}})]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }